module.exports = __webpack_public_path__ + "70317a52cb8a98037bbc7a1f161877a0.svg";